import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class FileData  {
    _originalTypeClassName = "zERP.BO.FileData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
FileData.translate = translateService;
}
this.Id = null;
this.FileName = null;
this.FolderPath = null;
this.MaxFileSize = null;
this.AllowedExtensions = null;
this.Blob = null;
this.StorageMedium = null;
this.UploadedBy = null;
this.UploadDateTime = null;
this.Description = null;
this._key = this.Id = "00000000-0000-0000-0000-000000000000"; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FileName:any;
FolderPath:any;
MaxFileSize:any;
AllowedExtensions:any;
Blob:any;
StorageMedium:any;
UploadedBy:any;
UploadDateTime:any;
Description:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == "00000000-0000-0000-0000-000000000000";
            }


}